const NATIONAL = 'Nacional'
const INTERNATIONAL = 'Internacional'
const AUTHORIZATIONS_INTERNATIONAL_TICKETS = 'authorize_international_tickets_days'
const AUTHORIZATIONS_NATIONAL_TICKETS = 'authorize_national_tickets_days'
const AUTHORIZATIONS_WITHOUT_TICKETS = 'authorize_without_tickets_days'

export {
    NATIONAL,
    INTERNATIONAL,
    AUTHORIZATIONS_WITHOUT_TICKETS,
    AUTHORIZATIONS_NATIONAL_TICKETS,
    AUTHORIZATIONS_INTERNATIONAL_TICKETS
}